<template>
  <v-form
    ref="form"
    v-model="isValidationOk"
    lazy-validation>
    <v-container
      v-if="Maglink.IsTechnicianUser()"
      mt-4
      py-0
      fill-height
      fluid
      grid-list-xl>
      <v-layout wrap>
        <v-flex
          xs6
          md2>
          <v-text-field
            :value="Maglink.GetCustomDateTime(dataSource.initialTime, systemSettings.dateFormat)"
            :disabled="true"
            :label="`${$t('Start date') + ' (' + $t(systemSettings.dateFormat) + ')'}`"
            class="dover-input" />
        </v-flex>
        <v-flex
          xs6
          md2>
          <v-text-field
            :value="Maglink.GetDayHourMinuteSecondFormat(dataSource.initialTime, dataSource.finalTime)"
            :disabled="true"
            :label="`${$t('Duration')}`"
            class="dover-input" />
        </v-flex>
        <v-flex
          xs6
          md2>
          <v-text-field
            :value="Maglink.GetDayHourMinuteSecondFormat(0, dataSource.totalTime)"
            :disabled="true"
            :label="`${$t('Segments time')}`"
            class="dover-input" />
        </v-flex>
        <v-flex
          xs6
          md2>
          <v-text-field
            :value="`${dataSource.validSegments + '/' + dataSource.invalidSegments}`"
            :disabled="true"
            :label="`${$t('No. of Segments')}`"
            class="dover-input" />
        </v-flex>
        <v-flex
          xs6
          md2>
          <v-text-field
            :value="Maglink.GetCustomDateTime(dataSource.finalTime, systemSettings.dateFormat)"
            :disabled="true"
            :label="`${$t('End date') + ' (' + $t(systemSettings.dateFormat) + ')'}`"
            class="dover-input" />
        </v-flex>
        <v-flex
          xs6
          md2/>
        <v-flex
          xs6
          md4>
          <v-text-field
            :value="testResult"
            :disabled="true"
            :label="`${$t('Last result')}`"
            class="dover-input" />
        </v-flex>
        <v-flex
          xs6
          md2>
          <v-text-field
            :value="testCode"
            :disabled="true"
            :label="`${$t('Calculation code')}`"
            class="dover-input" />
        </v-flex>
        <v-flex
          xs6
          md2>
          <v-text-field
            :value="Maglink.VolumeToDisplay(dataSource.dailyThroughput, systemSettings.volumeUnit)"
            :disabled="true"
            :label="`${$t('Daily Throughput') + ' (' + volUdm + ')'}`"
            class="dover-input" />
        </v-flex>
        <v-flex
          xs6
          md2>
          <v-text-field
            :value="dataSource.deliveryRatio > 0.0 ? convertNumber( 1 / dataSource.deliveryRatio, 1) : '--'"
            :disabled="true"
            :label="`${$t('Delivery Frequency') + ' (' + $t('Days') + ')'}`"
            class="dover-input" />
        </v-flex>
        <v-flex
          xs12
          md12
          lg12>
          <hr>
          <span>
            {{ $t('Statistics') }}
          </span>
          <hr>
        </v-flex>
        <v-flex
          xs12
          md12
          lg12>
          <v-data-table
            :headers="headers"
            :items="statistics"
            :no-data-text="`${Maglink.NoDataMessage(false)}`"
            :no-results-text="`${Maglink.NoDataMessage(true)}`"
            hide-actions>
            <template
              slot="headerCell"
              slot-scope="{ header }">
              <v-layout
                align-center
                column
                ma-0>
                <v-flex
                  align-self-center
                  shrink>
                  <span
                    class="dover-light-blue-color"
                    v-text="header.text" />
                </v-flex>
                <v-flex
                  align-self-center
                  shrink>
                  <span
                    class="dover-light-blue-color h6"
                    v-text="header.subtext" />
                </v-flex>
              </v-layout>
            </template>
            <template
              slot="items"
              slot-scope="{ item }">
              <tr class="text-xs-left">
                <td>{{ item.mode }}</td>
                <td
                  v-if="item.height !== '-'"
                  class="text-xs-center">{{ Maglink.LevelToDisplay(item.height, systemSettings.levelUnit) }}</td>
                <td v-else/>
                <td
                  v-if="item.temperature !== '-'"
                  class="text-xs-center">{{ formatTemperature(item.temperature) }}</td>
                <td v-else/>
                <td
                  v-if="item.segment !== '-'"
                  class="text-xs-center">{{ formatTemperature(item.segment) }}</td>
                <td v-else/>
                <td
                  v-if="item.length !== '-'"
                  class="text-xs-center">{{ Maglink.GetHourMinuteSecondFormatOfSeconds(item.length) }}</td>
                <td v-else/>
                <td
                  v-if="item.slope !== '-'"
                  class="text-xs-center">{{ Maglink.LeakageFormat(Maglink.LeakageToDisplay(item.slope, systemSettings.volumeUnit)) }}</td>
                <td v-else/>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
        <v-flex
          xs12
          md12
          lg12>
          <span>
            {{ $t('Diagnostics counters') }}
          </span>
          <hr>
        </v-flex>
        <v-flex
          xs12
          md12
          lg12>
          <v-data-table
            :headers="counterHeaders"
            :items="counterData"
            :no-data-text="`${Maglink.NoDataMessage(false)}`"
            :no-results-text="`${Maglink.NoDataMessage(true)}`"
            hide-actions>
            <template
              slot="headerCell"
              slot-scope="{ header }">
              <v-layout
                align-center
                column
                ma-0>
                <v-flex
                  align-self-center
                  shrink>
                  <span
                    class="dover-light-blue-color"
                    v-text="header.text" />
                </v-flex>
              </v-layout>
            </template>
            <template
              slot="items"
              slot-scope="{ index, item }">
              <tr
                :style="{ backgroundColor: backColor(index, item) }"
                class="text-xs-left">
                <td>{{ item.desc }}</td>
                <td class="text-xs-center">{{ item.code }}</td>
                <td class="text-xs-center">{{ item.count }}</td>
                <td class="text-xs-center">{{ Maglink.GetCustomDateTime(item.date, systemSettings.dateFormat) }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
        <template
          v-if="isManifold">
          <v-flex
            xs12
            md12
            lg12>
            <hr>
            <span>
              {{ $t('Manifold broken') }}
            </span>
            <hr>
          </v-flex>
          <v-flex
            xs6
            md2>
            <v-text-field
              :value="convertNumber(manifold.height1, 2)"
              :disabled="true"
              :label="`${'HT1'}`"
              class="dover-input" />
          </v-flex>
          <v-flex
            xs6
            md2>
            <v-text-field
              :value="convertNumber(manifold.htCode2, 2)"
              :disabled="true"
              :label="`${'HT2'}`"
              class="dover-input" />
          </v-flex>
          <v-flex
            xs6
            md2>
            <v-text-field
              :value="convertNumber(manifold.htNumB, 0)"
              :disabled="true"
              :label="`${'HTNumB'}`"
              class="dover-input" />
          </v-flex>
          <v-flex
            xs6
            md2>
            <v-text-field
              :value="convertNumber(manifold.htNumG, 0)"
              :disabled="true"
              :label="`${'HTNumG'}`"
              class="dover-input" />
          </v-flex>
          <v-flex
            xs12
            md4 />
          <v-flex
            xs6
            md2>
            <v-text-field
              :value="convertNumber(manifold.htDeltaStd, 4)"
              :disabled="true"
              :label="`${'HTDeltaStd'}`"
              class="dover-input" />
          </v-flex>
          <v-flex
            xs6
            md2>
            <v-text-field
              :value="convertNumber(manifold.htDeltaAvgB, 3)"
              :disabled="true"
              :label="`${'HTDeltaAvgB'}`"
              class="dover-input" />
          </v-flex>
          <v-flex
            xs6
            md2>
            <v-text-field
              :value="convertNumber(manifold.htDeltaAvgG, 3)"
              :disabled="true"
              :label="`${'HTDeltaAvgG'}`"
              class="dover-input" />
          </v-flex>
          <v-flex
            xs6
            md6 />
          <v-flex
            xs12
            md12
            lg12>
            <span>
              {{ $t('Manifold counters') }}
            </span>
            <hr>
          </v-flex>
          <v-flex
            xs12
            md12
            lg12>
            <v-data-table
              :headers="counterHeaders"
              :items="counterManifold"
              :no-data-text="`${Maglink.NoDataMessage(false)}`"
              :no-results-text="`${Maglink.NoDataMessage(true)}`"
              hide-actions>
              <template
                slot="headerCell"
                slot-scope="{ header }">
                <v-layout
                  align-center
                  column
                  ma-0>
                  <v-flex
                    align-self-center
                    shrink>
                    <span
                      class="dover-light-blue-color"
                      v-text="header.text" />
                  </v-flex>
                </v-layout>
              </template>
              <template
                slot="items"
                slot-scope="{ index, item }">
                <tr
                  :style="{ backgroundColor: backColor(index, item) }"
                  class="text-xs-left">
                  <td>{{ item.desc }}</td>
                  <td class="text-xs-center">{{ item.code }}</td>
                  <td class="text-xs-center">{{ item.count }}</td>
                  <td class="text-xs-center">{{ Maglink.GetCustomDateTime(item.date, systemSettings.dateFormat) }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
        </template>
      </v-layout>
    </v-container>
    <v-container
      v-else
      mt-4
      py-0
      fill-height
      fluid
      grid-list-xl>
      <v-layout
        wrap>
        <v-flex
          xs12
          md12>
          <span>{{ $t('Information available only for technical service') }}</span>
        </v-flex>
      </v-layout>
    </v-container>
  </v-form>
</template>

<script>

export default {
  props: {
    tank: {
      type: Object,
      required: true,
      default: () => { }
    },
    counters: {
      type: Object,
      required: true,
      default: () => { }
    },
    systemSettings: {
      type: Object,
      required: true,
      default: () => { }
    },
    options: {
      type: Object,
      required: true,
      default: () => { }
    },
    csldReasonCode: {
      type: Array,
      required: true,
      default: () => []
    },
    csldReasonDesc: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data: () => ({
    isValidationOk: false,
    dataSource: {},
    headers: [],
    counterHeaders: [],
    statistics: [],
    manifold: [],
    isManifold: false,
    counterData: [],
    counterManifold: [],
    levUdm: '',
    tempUdm: '',
    volUdm: '',
    testResult: '',
    testCode: ''
  }),
  watch: {
    counters: {
      immediate: true,
      deep: true,
      handler (newVal, oldVal) {
        this.counterData = [
          { desc: this.$t('Passed tests'), code: 'P', count: newVal.passedTests, date: newVal.lastPassed },
          { desc: this.$t('Leak detected'), code: 'F', count: newVal.leakDetected, date: newVal.lastLeak },
          { desc: this.$t('High leak rate variation'), code: 'I1', count: newVal.highLeakRate, date: newVal.lastHighLeakRate },
          { desc: this.$t('Product gain during test'), code: 'I5', count: newVal.productGain, date: newVal.lastProductGain },
          { desc: this.$t('Insufficient data'), code: 'ND', count: newVal.insufficientData, date: newVal.lastInsufficientData },
          { desc: this.$t('High temperature changes'), code: 'MT', count: newVal.highTemperature, date: newVal.lastHighTemperature },
          { desc: this.$t('Bottom temperature deviation'), code: 'MR', count: newVal.bottomTemperature, date: newVal.lastBottomTemperature },
          { desc: this.$t('Temperature noise'), code: 'TN', count: newVal.tempNoise, date: newVal.lastTempNoise },
          { desc: this.$t('Product height noise'), code: 'HN', count: newVal.heightNoise, date: newVal.lastHeightNoise },
          { desc: this.$t('Invalid thermal expansion'), code: 'TE', count: newVal.thermalExpansion, date: newVal.lastTermalExpansion }
        ]

        this.counterManifold = [
          { desc: this.$t('Height differential'), code: 'HD', count: newVal.heightDifferential, date: newVal.lastHeightDifferential },
          { desc: this.$t('Manifold broken'), code: 'MB', count: newVal.manifoldBroken, date: newVal.lastManifoldBroken },
          { desc: this.$t('Jump counter'), code: 'J20', count: newVal.jumpCounter, date: newVal.lastJumpCounter },
          { desc: this.$t('Not enough segments'), code: 'I8', count: newVal.notEnoughSegments, date: newVal.lastNotEnoughSegments }
        ]
      }
    },
    tank: {
      immediate: true,
      deep: true,
      handler (newVal, oldVal) {
        this.dataSource = newVal.sldLeakage
        this.manifold = newVal.manifold
        this.isManifold = newVal.manifoldType !== 0

        let measure = newVal.lastMeasurement

        let enabled = newVal.enabled
        let status = newVal.lastAlarm.tankStatus & 32

        let productLevel = measure.productLevel
        let temperature = measure.temperature

        if (enabled === 0 || status === 32) {
          productLevel = '-'
          temperature = '-'
        }

        if (newVal.lastAlarm.tankStatus & 4096) {
          if (newVal.lastSldReport.finalTime === 0) {
            this.testResult = this.$t('Stopped').toUpperCase()
            this.testCode = '-'
          } else {
            this.testResult = this.csldReasonDesc[newVal.lastSldReport.reason]
            this.testCode = this.csldReasonCode[newVal.lastSldReport.reason]
          }
        } else {
          if (newVal.lastSldReport.finalTime === 0) {
            this.testResult = this.$t('Test in progress').toUpperCase()
            this.testCode = '-'
          } else {
            this.testResult = this.csldReasonDesc[newVal.lastSldReport.reason]
            this.testCode = this.csldReasonCode[newVal.lastSldReport.reason]
          }
        }

        this.statistics = [
          { mode: this.$t('Max'), height: this.dataSource.maxHeight, temperature: this.dataSource.maxTemp, segment: this.dataSource.maxTempSeg, length: this.dataSource.maxLength, slope: this.dataSource.maxMn },
          { mode: this.$t('Avg'), height: this.dataSource.avrHeight, temperature: this.dataSource.avrTemp, segment: this.dataSource.avrTempSeg, length: '-', slope: this.dataSource.avrMn },
          { mode: this.$t('Min'), height: this.dataSource.minHeight, temperature: this.dataSource.minTemp, segment: this.dataSource.minTempSeg, length: this.dataSource.minLength, slope: this.dataSource.minMn },
          { mode: this.$t('Variance'), height: '-', temperature: this.dataSource.varTemp, segment: this.dataSource.varTempSeg, length: '-', slope: this.dataSource.varMn },
          { mode: this.$t('Current'), height: productLevel, temperature: temperature, segment: '-', length: '-', slope: '-' }
        ]
      }
    }
  },
  mounted () {
    this.levUdm = this.options.levelUnits[this.systemSettings.levelUnit || 0].desc
    this.tempUdm = this.options.temperatureUnits.find(c => c.code === this.systemSettings.temperatureUnit).desc
    this.volUdm = this.options.volumeUnits[this.systemSettings.volumeUnit || 0].desc

    this.headers = [
      { sortable: false, text: '', subtext: '', align: 'center' },
      { sortable: false, text: this.$t('Product height'), subtext: this.levUdm, align: 'center' },
      { sortable: false, text: this.$t('Product temperature'), subtext: this.tempUdm, align: 'center' },
      { sortable: false, text: this.$t('Segment temperature'), subtext: this.tempUdm, align: 'center' },
      { sortable: false, text: this.$t('Segment length'), subtext: '', align: 'center' },
      { sortable: false, text: this.$t('Slope'), subtext: this.Maglink.LeakShortUdm(this.systemSettings.volumeUnit), align: 'center' }
    ]

    this.counterHeaders = [
      { sortable: false, text: '', align: 'center' },
      { sortable: false, text: this.$t('Code'), align: 'center' },
      { sortable: false, text: this.$t('Count'), align: 'center' },
      { sortable: false, text: this.$t('Last date'), align: 'center' }
    ]
  },
  methods: {
    backColor (index, item) {
      if (item.aborted) return '#ffdddd'

      return ((index % 2 === 0) ? '#cfdbfb' : 'transparent')
    },
    convertNumber (value, decimal) {
      let data = Number(parseFloat(value)).toFixed(10).toString()
      return this.Maglink.RoundFormat(data, decimal)
    },
    formatTemperature (value) {
      if (value * 1.0 >= 999.0) {
        return '-'
      }

      return this.Maglink.TemperatureFormat(this.Maglink.TemperatureToDisplay(value, this.systemSettings.temperatureUnit))
    }
  }
}
</script>
